module.exports = __webpack_public_path__ + "static/media/lumbarSpine-quizz.a183dd28.jpg";